import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Card } from "@/components/admin/Primitives";

export default function Inquiries() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/inquiries").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this inquiry?")) return;
    await api.delete(`/admin/inquiries/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-inquiries-page" className="text-white">
      <PageHeader title="Inquiries" subtitle="Contact form messages from your site." />
      <Card className="!p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="text-[10px] uppercase tracking-[0.15em] text-zinc-500 border-b border-[var(--pz-line)]">
                <th className="px-5 py-3 font-bold">When</th>
                <th className="px-5 py-3 font-bold">Name</th>
                <th className="px-5 py-3 font-bold">Phone / Email</th>
                <th className="px-5 py-3 font-bold">Subject</th>
                <th className="px-5 py-3 font-bold">Message</th>
                <th className="px-5 py-3 text-right font-bold">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((row) => (
                <tr key={row.id} className="border-b border-[var(--pz-line)]/50 hover:bg-white/[0.03] align-top text-zinc-200">
                  <td className="px-5 py-3 text-sm text-zinc-500">{new Date(row.created_at).toLocaleString()}</td>
                  <td className="px-5 py-3 text-sm font-bold text-white">{row.name}</td>
                  <td className="px-5 py-3 text-sm">{row.phone}<br /><span className="text-zinc-500">{row.email || "—"}</span></td>
                  <td className="px-5 py-3 text-sm">{row.subject}</td>
                  <td className="px-5 py-3 text-sm max-w-md">{row.message}</td>
                  <td className="px-5 py-3 text-right">
                    <button onClick={() => remove(row.id)} className="h-8 w-8 grid place-items-center rounded-full hover:bg-rose-500/10 text-rose-400 inline-grid"><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-zinc-500">No inquiries yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
